import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchJobById } from '../store/jobThunk';

import { clearSelectedJob } from '../store/jobSlice';

export const useJob = (jobId?: string) => {
  const dispatch = useDispatch<any>();

  const { selectedJob, loading, error } = useSelector((state: any) => state.jobs);

  useEffect(() => {
    if (!jobId) return;

    dispatch(fetchJobById(jobId));

    return () => {
      dispatch(clearSelectedJob());
    };
  }, [dispatch, jobId]);

  return {
    job: selectedJob,
    loading,
    error,
  };
};
